module.exports = __webpack_public_path__ + "img/winning_decoration_bg.3c598d7d.png";